import { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import type { AlertColor } from '@mui/material/Alert';
import Alert from '@mui/material/Alert';

const FrameworkSnackbar = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState<AlertColor>('success');

  const openSnackbar = (e: Event) => {
    const { text, severity } = (e as CustomEvent).detail;
    setMessage(text);
    setSeverity(severity);
    setOpen(true);
  };

  useEffect(() => {
    window.addEventListener('OSTS_SHOW_USER_NOTIFICATION', openSnackbar);

    return () => {
      window.removeEventListener('OSTS_SHOW_USER_NOTIFICATION', openSnackbar);
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
    setMessage('');
    setSeverity('success');
  };

  return (
    <div>
      <Snackbar
        sx={{
          '&.MuiSnackbar-root': { top: '85px', position: 'absolute' },
        }}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={severity} variant="filled" sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default FrameworkSnackbar;
